var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1679_194020)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.734961 7.89941H35.1094L38.6016 19.0745V25.0994H32.6683V23.8994H37.4016V19.2576L34.2272 9.09941H1.93496V23.8994H7.33496V25.0994H0.734961V7.89941ZM12.6683 23.8994H27.335V25.0994H12.6683V23.8994Z",
    fill: "#0C2487"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7333 16.5001V8.50007H15.9333V16.5001H14.7333ZM19.4 16.5001V8.50007H20.6V16.5001H19.4ZM28.7333 16.5001V8.50007H29.9333V16.5001H28.7333ZM17.4 24.5001V16.5001H18.6V24.5001H17.4ZM22.0667 24.5001V16.5001H23.2667V24.5001H22.0667Z",
    fill: "#0C2487"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.40163 15.8994V8.49941H6.60163V15.8994H37.335V17.0994H1.33496V15.8994H5.40163Z",
    fill: "#0C2487"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0007 25.9662C11.1789 25.9662 12.134 25.0111 12.134 23.8329C12.134 22.6547 11.1789 21.6996 10.0007 21.6996C8.82244 21.6996 7.86732 22.6547 7.86732 23.8329C7.86732 25.0111 8.82244 25.9662 10.0007 25.9662ZM10.0007 27.1662C11.8416 27.1662 13.334 25.6739 13.334 23.8329C13.334 21.992 11.8416 20.4996 10.0007 20.4996C8.1597 20.4996 6.66732 21.992 6.66732 23.8329C6.66732 25.6739 8.1597 27.1662 10.0007 27.1662Z",
    fill: "#0C2487"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0006 25.9662C31.1789 25.9662 32.134 25.0111 32.134 23.8329C32.134 22.6547 31.1789 21.6996 30.0006 21.6996C28.8224 21.6996 27.8673 22.6547 27.8673 23.8329C27.8673 25.0111 28.8224 25.9662 30.0006 25.9662ZM30.0006 27.1662C31.8416 27.1662 33.334 25.6739 33.334 23.8329C33.334 21.992 31.8416 20.4996 30.0006 20.4996C28.1597 20.4996 26.6673 21.992 26.6673 23.8329C26.6673 25.6739 28.1597 27.1662 30.0006 27.1662Z",
    fill: "#0C2487"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6663 30.5002H37.9997V31.8336H18.6663V30.5002ZM13.333 33.8336H27.333V35.1669H13.333V33.8336Z",
    fill: "#0C2487"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4.0026 30.5002H15.3307V31.8336H-4.0026V30.5002ZM-9.33594 33.8336H4.66406V35.1669H-9.33594V33.8336Z",
    fill: "#0C2487"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1679_194020"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusBlue);
export default __webpack_public_path__ + "static/media/bus_blue.5df326b3d3d886bff510fca808172c9b.svg";
export { ForwardRef as ReactComponent };